import React, { useState } from 'react';
import '../styles/pages/Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the form data to your server
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        <div className="contact-info-column">
          <div className="info-item">
            <i className="fas fa-map-marker-alt"></i>
            <div className="info-content">
              <h3>Visit Us</h3>
              <p>15260 Highway 105 W Suite 116</p>
              <p>Montgomery, TX 77356</p>
            </div>
          </div>

          <div className="info-item">
            <i className="fas fa-phone"></i>
            <div className="info-content">
              <h3>Call Us</h3>
              <p><a href="tel:(936) 588-7070">(936) 588-7070</a></p>
            </div>
          </div>

          <div className="info-item">
            <i className="fas fa-clock"></i>
            <div className="info-content">
              <h3>Hours</h3>
              <p>Monday - Thursday: 11:00 AM - 10:00 PM</p>
              <p>Friday - Saturday: 11:00 AM - 11:00 PM</p>
              <p>Sunday: 11:00 AM - 9:00 PM</p>
            </div>
          </div>

          <div className="info-item">
            <i className="fas fa-envelope"></i>
            <div className="info-content">
              <h3>Email Us</h3>
              <p><a href="mailto:info@texascraftwings.com">info@texascraftwings.com</a></p>
            </div>
          </div>
        </div>

        <div className="contact-form-column">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Your Name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="your@email.com"
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="(123) 456-7890"
              />
            </div>

            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
                placeholder="How can we help?"
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                placeholder="Your message here..."
                rows="5"
              ></textarea>
            </div>

            <button type="submit" className="submit-button">
              Send Message
            </button>

            {submitted && (
              <div className="success-message">
                <i className="fas fa-check-circle"></i>
                Thank you for your message! We'll get back to you soon.
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
